import { createSelector } from '@reduxjs/toolkit';
import { selectMobile, selectMobileConnectionBlockData, selectMobileConnectionPrice, selectTariffLink } from "../../../store/selectors";
import { convertAccumulators } from "../../../utils/accumulators";
export var selectTariffUrl = createSelector([selectTariffLink], function (url) {
  var _window, _window$abTestChoices;
  if (url && (_window = window) !== null && _window !== void 0 && (_window$abTestChoices = _window.abTestChoices) !== null && _window$abTestChoices !== void 0 && _window$abTestChoices.elkTariffLinks) {
    return url;
  }
  return '/customers/products/mobile/profile/';
});
var selectSharing = function selectSharing(state) {
  var _selectMobileConnecti;
  return (_selectMobileConnecti = selectMobileConnectionBlockData(state)) === null || _selectMobileConnecti === void 0 ? void 0 : _selectMobileConnecti.sharing;
};
export var selectSharingList = function selectSharingList(state) {
  var _selectSharing;
  return (_selectSharing = selectSharing(state)) === null || _selectSharing === void 0 ? void 0 : _selectSharing.children;
};
export var selectParentInfo = function selectParentInfo(state) {
  var _selectSharing2;
  return (_selectSharing2 = selectSharing(state)) === null || _selectSharing2 === void 0 ? void 0 : _selectSharing2.parentInfo;
};
var selectAccumulators = function selectAccumulators(state) {
  var _selectMobileConnecti2;
  return (_selectMobileConnecti2 = selectMobileConnectionBlockData(state)) === null || _selectMobileConnecti2 === void 0 ? void 0 : _selectMobileConnecti2.accumulators;
};
export var selectMobileConnectionAccumulatorsItems = function selectMobileConnectionAccumulatorsItems(state) {
  var _selectAccumulators;
  return (_selectAccumulators = selectAccumulators(state)) === null || _selectAccumulators === void 0 ? void 0 : _selectAccumulators.items;
};
export var selectMobileConnectionAccumulators = function selectMobileConnectionAccumulators(state) {
  return convertAccumulators(selectMobileConnectionAccumulatorsItems(state));
};
export var selectFamilyBlock = function selectFamilyBlock(state) {
  return selectMobile(state).family;
};
export var selectFamilyTexts = function selectFamilyTexts(state) {
  return selectFamilyBlock(state).texts;
};
export var selectRedesignMobileConnectionPrice = selectMobileConnectionPrice;
export var selectTariffPrice = function selectTariffPrice(state) {
  var _selectRedesignMobile, _selectRedesignMobile2;
  return (_selectRedesignMobile = selectRedesignMobileConnectionPrice(state)) === null || _selectRedesignMobile === void 0 ? void 0 : (_selectRedesignMobile2 = _selectRedesignMobile.data) === null || _selectRedesignMobile2 === void 0 ? void 0 : _selectRedesignMobile2.rcRate;
};
export var selectTariffPeriodDays = function selectTariffPeriodDays(state) {
  var _selectRedesignMobile3, _selectRedesignMobile4;
  return (_selectRedesignMobile3 = selectRedesignMobileConnectionPrice(state)) === null || _selectRedesignMobile3 === void 0 ? void 0 : (_selectRedesignMobile4 = _selectRedesignMobile3.data) === null || _selectRedesignMobile4 === void 0 ? void 0 : _selectRedesignMobile4.rcRatePeriodDays;
};
export var selectMobileConnectionBlockPending = function selectMobileConnectionBlockPending(state) {
  var _selectMobile;
  return (_selectMobile = selectMobile(state)) === null || _selectMobile === void 0 ? void 0 : _selectMobile.pending;
};
export var selectMobileConnectionBlockPricePending = function selectMobileConnectionBlockPricePending(state) {
  var _selectMobile2, _selectMobile2$price;
  return (_selectMobile2 = selectMobile(state)) === null || _selectMobile2 === void 0 ? void 0 : (_selectMobile2$price = _selectMobile2.price) === null || _selectMobile2$price === void 0 ? void 0 : _selectMobile2$price.pending;
};